import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, Box, Container, Toolbar } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useAuth } from '../contexts/auth-context';
import { useDemoMode } from '../contexts/demo-mode-context';

export default function MainLayout() {
    const { user, pendingPasswordReset } = useAuth();
    const { redactionActive } = useDemoMode();
    const showAuthenticatedUI = user && !pendingPasswordReset;
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Header sidebarOpen={sidebarOpen} />
            {showAuthenticatedUI && <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh'
                }}
            >
                {/* Toolbar spacer to push content below fixed header */}
                <Toolbar />
                <Container 
                    maxWidth={false}
                    sx={{ 
                        flexGrow: 1, 
                        py: showAuthenticatedUI ? 3 : 0,
                        px: showAuthenticatedUI ? 3 : 0,
                        maxWidth: '100%'
                    }}
                >
                    {showAuthenticatedUI && redactionActive && (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Demo mode is on: dashboard, sensor overview, and historical views use synthetic location names (Demo Water 1, …) with real sensor ids; issues may still hide sensor text. URLs use an internal cfg id — treat shared links as sensitive. Turn off demo mode in Admin → My Assignment.
                        </Alert>
                    )}
                    <Outlet />
                </Container>
                <Footer />
            </Box>
        </Box>
    );
}
